import React from 'react';

import ShoppingDetail from 'components/Tvendo/Shopping/Operations/Show';

export default function () {
  return <ShoppingDetail />;
}
